'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var Url = require('../util/url');
var NAME = 'pv';

var PvManager = function () {
    function PvManager(cfgManager) {
        _classCallCheck(this, PvManager);

        this.cfgManager = cfgManager;
    }

    _createClass(PvManager, [{
        key: 'report',
        value: function report(opts) {
            opts = opts || {};
            var cfgManager = this.cfgManager;
            var ext = cfgManager.getExtension();
            var url = Url.stringify(cfgManager.getApiPath(NAME), {
                project: opts.project || cfgManager.get('project'),
                pageurl: encodeURIComponent(opts.pageUrl || cfgManager.get('pageUrl')),
                pageId: opts.pageId || cfgManager.get('pageId'),
                timestamp: Date.now(),
                region: ext.region || '',
                operator: ext.operator || '',
                network: ext.network || '',
                container: ext.container || '',
                os: ext.os || '',
                unionid: ext.unionId || ''
            });
            Ajax({
                url: url,
                type: 'POST',
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        }
    }]);

    return PvManager;
}();

module.exports = PvManager;